(ns app.front.ui.panels
  (:require [app.front.ui.dom :as dom]
            [re-frame.core-instrumented :as rf]))

;; IDs of panels that should be left open on navigation
(def persistent-panels #{:chat :messages :service-hub})

;; Holds the panel id of the currently open panel, a vector of the form [:panel-kind panel-opts],
;; e.g. [:options {}], [:tasks {}], [:service-hub {}], [:cta {:index 2}], ...
(rf/reg-sub ::open-panel :-> :ui/open-panel)

;; For convenience, the panel id in query vectors can also be a panel-kind keyword, like :tasks, meaning [:tasks {}].
;; For ::open? a panel-kind keyword asks, "is the open-panel of this kind?".

;; Convenience: ask "is id open?"
(rf/reg-sub ::open?
  :<- [::open-panel]
  (fn [open-panel [_ id]]
    (if (keyword? id)
      (= (first open-panel) id)
      (= open-panel id))))

(defn ->panel-id [id]
  (if (keyword? id) [id {}] id))

;; Open exactly one panel (closing others implicitly)
(rf/reg-event-fx ::open
  (fn [{:keys [db]} [_ id]]
    {:db (assoc db :ui/open-panel (->panel-id id))
     :fx [[:dispatch [::toggle-mobile-menu-open true]]]}))

;; Toggle a panel (close if already open)
(rf/reg-event-fx ::toggle
  (fn [{:keys [db]} [_ id]]
    (let [id        (->panel-id id)
          was-open? (= id (:ui/open-panel db))]
      {:db (update db :ui/open-panel #(when-not (= % id) id))
       :fx [[:dispatch [::toggle-mobile-menu-open (not was-open?)]]]})))

;; Close all panels
(rf/reg-event-fx ::close-all
  (fn [{:keys [db]} [_ keep-mobile-menu-open?]]
    {:db (cond-> (dissoc db :ui/open-panel)
           (not keep-mobile-menu-open?) (dissoc ::mobile-menu-open?))
     :fx [[:dispatch [::dom/toggle-body-overflow]]]}))

;; Close all panels except AI chat and messages, which should persist across navigations.
(rf/reg-event-fx ::close-all-except-persistent
  (fn [{:keys [db]} [_ keep-mobile-menu-open?]]
    (let [chat-open?         (some-> db :ui/open-panel first persistent-panels)
          close-mobile-menu? (not keep-mobile-menu-open?)]
      (cond-> {:db (cond-> db
                     (not chat-open?)   (dissoc :ui/open-panel)
                     close-mobile-menu? (dissoc ::mobile-menu-open?))}
        (and close-mobile-menu? (::mobile-menu-open? db))
        (assoc :fx [[:dispatch [::dom/toggle-body-overflow]]])))))

(rf/reg-sub ::mobile-menu-open?
  :-> ::mobile-menu-open?)

(rf/reg-event-fx ::toggle-mobile-menu-open
  (fn [{:keys [db]} [_ open?]]
    (let [was-open?    (::mobile-menu-open? db)
          should-open? (if (nil? open?)
                         (not was-open?)
                         open?)]
      {:db (assoc db ::mobile-menu-open? should-open?)
       :fx [[:dispatch [::dom/toggle-body-overflow]]
            (when (and was-open? (not should-open?))
              [:dispatch [::close-all]])]})))
